import PropTypes, { string } from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField from '@mui/material/TextField';
import { InputAdornment, MenuItem } from '@mui/material';
import Iconify from '../iconify/iconify';

// ----------------------------------------------------------------------

export default function RHFTextField({
  name,
  helperText,
  type,
  iconName,
  iconSize,
  holder,
  optionsMenu = [],
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={(event) => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          placeholder={holder}
          InputLabelProps={{
            // shrink: !!field.value || !!holder,  
            shrink: true,  
            ...other.InputLabelProps, 
          }}
          {...other}
        />
      )}
    />
  );
}
const objectOption = { value: string, label: string };
RHFTextField.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  iconName: PropTypes.string,
  iconSize: PropTypes.number,
  optionsMenu: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  holder: PropTypes.string,
};
